import { FormControl, FormLabel, Grid, GridItem, Select } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { HomeownerDigestTrackingEventLocation } from '../../../constants/tracking'
import history from '../../../history'
import { selectClientHomes, selectClientId } from '../../../store/selectors/client'
import { selectHomeId } from '../../../store/selectors/home'
import { routeToHome } from '../../../store/selectors/routes'
import { setIsShortcutsDrawerOpen } from '../../../store/slices/navigation'
import { MobileShortcutsDrawer } from '../../shared/MobileShortcutsDrawer/MobileShortcutsDrawer'
import { HubTile } from '../../shared/HubTile'
import { useJumpToOptions } from '../HomeownerSidebar/useJumpToOptions'
import { useQuickActions } from '../HomeownerSidebar/useQuickActions'
import { selectHomeDigestLoading } from '../../../store/selectors/display'
import { MobileShortcutsDrawerHeader } from '../../shared/MobileShortcutsDrawer/MobileShortcutsDrawerHeader'
import { MobileShortcutsDrawerGroup } from '../../shared/MobileShortcutsDrawer/MobileShortcutsDrawerGroup'

export const MSG = defineMessages({
  yourAddresses: {
    id: 'HomeownerShortcutsDrawerContent.yourAddresses',
    defaultMessage: 'Your addresses'
  },
  jumpTo: {
    id: 'MobileShortcutsDrawer.shortcutsDrawerContent.jumpTo',
    defaultMessage: 'Jump to'
  },
  quickActions: {
    id: 'MobileShortcutsDrawer.shortcutsDrawerContent.quickActions',
    defaultMessage: 'Quick Actions'
  }
})

export const HomeownerShortcutsDrawer = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  // Lots of race condition issues require me to
  // know when loading is done to start animations on
  // the shortcuts drawer.
  const isLoading = useSelector(selectHomeDigestLoading)

  const clientId = useSelector(selectClientId)
  const homes = useSelector(selectClientHomes)
  const currentHomeId = useSelector(selectHomeId)
  const jumpToOptions = useJumpToOptions()
  const quickActions = useQuickActions()

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setIsShortcutsDrawerOpen(false))
    history.push(routeToHome(clientId, e.target.value))
  }

  return (
    <MobileShortcutsDrawer isLoading={isLoading}>
      <MobileShortcutsDrawerHeader>
        {homes?.length > 1 && (
          <FormControl>
            <FormLabel>{intl.formatMessage(MSG.yourAddresses)}</FormLabel>
            <Select
              name='home addresses'
              value={currentHomeId}
              onChange={handleOnChange}
              tracking={{
                guid: 'iCKaifg3uSPexfLku7Udee',
                ui_context:
                  HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_MOBILE_SHORTCUTS_DRAWER_SELECT_COMPONENT,
                descriptor: MSG.yourAddresses.defaultMessage
              }}
            >
              {homes.map(home => (
                <option value={home.id} key={home.id}>
                  {home.address?.street}
                </option>
              ))}
            </Select>
          </FormControl>
        )}
      </MobileShortcutsDrawerHeader>
      <MobileShortcutsDrawerGroup title={intl.formatMessage(MSG.jumpTo)}>
        <Grid gridTemplateColumns='repeat(auto-fill, minmax(98px, 1fr))' gap={2}>
          {jumpToOptions.map(option => {
            return (
              <GridItem key={option.name}>
                <HubTile option={option} />
              </GridItem>
            )
          })}
        </Grid>
      </MobileShortcutsDrawerGroup>
      <MobileShortcutsDrawerGroup title={intl.formatMessage(MSG.quickActions)}>
        <Grid templateColumns='repeat(auto-fill, minmax(144px, 1fr))' gap={2} alignItems='stretch'>
          {quickActions.map(option => {
            return (
              <GridItem key={option.name} height='100%'>
                <HubTile option={option} variant='wide' />
              </GridItem>
            )
          })}
        </Grid>
      </MobileShortcutsDrawerGroup>
    </MobileShortcutsDrawer>
  )
}
